module.exports = __webpack_public_path__ + "resources/img/img_tibero2.163530edbee79b1e9f4e1b414e9ae096.png";